import { openBlock as l, createElementBlock as r, createElementVNode as e } from "vue";
const h = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function o(n, t) {
  return l(), r("svg", h, [...t[0] || (t[0] = [
    e("g", {
      fill: "currentColor",
      "clip-path": "url(#a)"
    }, [
      e("path", { d: "M9 4H7v2H5v12h2v2h2v-2h2V6H9zm0 12H7V8h2zm10-8h-2V4h-2v4h-2v7h2v5h2v-5h2zm-2 5h-2v-3h2z" })
    ], -1),
    e("defs", null, [
      e("clipPath", { id: "a" }, [
        e("path", {
          fill: "currentColor",
          d: "M0 0h24v24H0z"
        })
      ])
    ], -1)
  ])]);
}
const a = { render: o };
export {
  a as default,
  o as render
};
